module.exports = __webpack_public_path__ + "static/media/bring-front.63b9c384.svg";